/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ApiException, ApiSuccessResponse } from '../../../types/Rest';

export class ThrowError {
    static readonly type = '[Notification] Throw Error';

    constructor(public exception: ApiException) {}
}

export class ShowError {
    static readonly type = '[Notification] Show error message';

    constructor(public message: string) {}
}


export class ShowWarning {
    static readonly type = '[Notification] Warning';

    constructor(public message: string) {}
}

export class ShowSuccess {
    static readonly type = '[Notification] Show success message';

    constructor(public message: string) {}
}

export class ShowInfo {
    static readonly type = '[Notification] Show info message';
    
    constructor(public message: string) {}
}


export class HandleApiResult {
    static readonly type = '[Notification] Handle an unexpected API result';

    constructor(public payload: {result: ApiSuccessResponse; message: string}) {}
}

